import zhLocale from "element-ui/lib/locale/lang/zh-CN.js";

const localZhLocale = {
    ...zhLocale,
    title: "确定",
    userQuestion: "用户咨询",
    transform: "转人工",
    message: "留言",
    camera: "拍照",
    file: "文件",
    evaluate: "评价",
    eval_title: "满意度评价",
    eval_desc: " 是否已帮您解决问题？",
    eval_submit: "提交评价",
    msg_title: "填写留言",
    msg_submit: "提交留言",
    msg_desc: "如需帮助请留言，我们将尽快联系并解决您的问题",
    sendBtn: "发送",
    tips: "提示",
    sure: "确定",
    cancel: "取消",
    closeTips: "此操作将断开当前聊天, 是否继续?",
    customerInputIng: "客服正在输入...",
    historyChat: "以上是历史会话",
    loading: "正在加载...",
    noHistory: "没有更多记录了",
    download: "下载",
    input: "请输入",
    orderStatus: "订单状态",
    orderNumber: "订单编号",
    showDetail: "查看详情",
    orderTime: "订单时间",
    thump: "点赞",
    top: "点踩",
    submit: "提交",
    pleInput: "请填写",
    content: "内容！",
    rightPhone: "请填写正确的手机号！",
    rightEmail: "请填写正确的邮箱！",
    emoji: "表情",
    leaveMsg: "留言",
    uploadFile: "上传文件",
    reChat: "重新会话",
    chatAfterEva: "服务评价可在完成咨询后提供",
    veryGood: "非常满意，五分好评",
    notGood: "不是很满意，还有待提升",
    userName: "联系姓名",
    userPhone: "联系电话",
    userEmail: "邮箱地址",
    leaveMsgCon: "留言内容",
    submitLeave: "提交留言",
    getHistory: "获取历史记录",
    isResolved: "是否已帮您解决问题？",
    leaveTip: "小主，我做的还不够，还需要努力学习",
    leaveInput: "欢迎给我们的服务提意见!",
    solved: "已解决",
    noSolved: "未解决",
    submitEva: "提交评价",
    evaConInput: "请填写评价内容！",
    evaLabelSelect: "请选择评价标签！",
    robotEva1: "答非所问",
    robotEva2: "理解能力差",
    robotEva3: "不能回答问题",
    robotEva4: "不礼貌",
    customerEva1: "服务态度差",
    customerEva2: "回答不及时",
    customerEva3: "没解决问题",
    customerEva4: "不礼貌",
    leaveMessage: "以下为离线消息",
    helloMsg: "您好，有什么可以帮你",
    noCustomer: "暂无客服在线",
    isSureLeave: "确定离开当前页面吗？",
    customer: "客服",
    connectChat: "与您建立了会话",
    busyMessage: "客服已经忙翻啦",
    transferFailed: "转人工失败！",
    notWork: "客服已经下班了！",
    closeChat: "客服与您的对话已结束！",
    newWindow: "您的会话在新窗口打开！",
    chatOver: "客服与您的对话已结束！",
    backMessage: "客服撤回了一条消息！",
    thankMessage: "感谢您的评价！",
    fileMax: "文件不能大于10M！",
    newMessage: "【您收到一条新消息】",
    inputUserName: "请输入联系姓名!",
    inputUserPhone: "请填写正确的手机号!",
    inputUserEmail: "请填写正确的邮箱!",
    inputLeaveMsg: "请输入留言内容!",
    submitSuc: "提交成功!",
    replay: "回复",
    leaveHis: "留言记录",
    today: "今天",
    onlyIMG: '文件类型有误，仅能发送图片或影片!',
    enclosure: '附件',
    createTime: '创建时间',
    updateTime: '更新时间',
    woStatus: "留言状态",
    orderNoYet:'尚未受理',
    orderAccept:'受理中',
    orderWait:'等待回复',
    orderResolved:'已解决',
    orderOver:'已关闭',
    orderPriority:'优先级',
    orderDanger:'紧急',
    orderWarning:'高',
    orderNormal:'中',
    orderLow:'低',
    reply:'回复',
    client:'用户',
    txbj:'您好，很抱歉我们暂时无法为您提供服务，如需帮助，请留言，我们将尽快联系并解决您的问题',
    messageName:'客户姓名',
    messageEmail:'客户邮箱',
    messagePhone:'客户电话',
    messageContent:'留言内容',
    messageSubmitTime:'提交时间',
    messageStatus:'留言状态',
    messageDealTime:'处理时间',
    haveDeal:'已处理',
    noDeal:'未处理',
    remark:'备注',
    attachments: '附件',

}
export default localZhLocale;



// WEBPACK FOOTER //
// ./src/language/zh.js